export default "__VITE_ASSET__37674178__"